import type {
  CreateLevelRequest,
  EditLevelRequest,
  LevelDeleteRequest,
  LevelRestoreRequest,
} from 'shared/domain/messages/level/eventMessages';
import { broadcastAllLevels } from 'serviceWorker/broadcasts/levels';
import * as levels from 'serviceWorker/db/levels/levels';
import * as levelsService from 'serviceWorker/db/levels/levelsService';
import { debugLog } from 'shared/logger/debugLog';
import { levelSaver } from './addLevel';
import { levelDeleter } from './deleteLevel';
import { levelEditor } from './editLevel';
import { fetchLevels, fetchUpdatedLevels } from './fetchLevels';
import { levelRestorer } from './restoreLevel';
import { Services } from 'shared/domain/messages/message';
import { levelContract } from 'shared/domain/level/levelContract';
import { createSyncedEntity } from '../factories/createSyncedEntity';

/** Download and sync of the levels; the source's `sync` is its entry point. */
export const levelsSync = createSyncedEntity({
  entityName: Services.LEVELS,
  contract: levelContract,
  repository: levels,
  service: levelsService,
  fetch: fetchLevels,
  fetchUpdated: fetchUpdatedLevels,
  publishCollection: broadcastAllLevels,
});

/**
 * Resolves once the change is in the HTTP queue and rejects only when it could
 * not be queued. The server's answer follows as an event (`uploadedEntity`,
 * `failUploadedEntity`, …) with the change's `uniqueId`.
 */
export function handleAddLevel(detail: CreateLevelRequest): Promise<void> {
  debugLog('addLevel', detail);
  return levelSaver.execute(detail.level, detail.uniqueId);
}

export function handleEditLevel(detail: EditLevelRequest): Promise<void> {
  debugLog('editLevel', detail);
  return levelEditor.execute(detail.level, detail.uniqueId);
}

export function handleDeleteLevel(detail: LevelDeleteRequest): Promise<void> {
  debugLog('deleteLevel', detail);
  return levelDeleter.execute({
    levelId: detail.levelId,
    uniqueId: detail.uniqueId,
    projectId: detail.projectId,
  });
}

export function handleRestoreLevel(detail: LevelRestoreRequest): Promise<void> {
  debugLog('restoreLevel', detail);
  return levelRestorer.execute({
    levelId: detail.levelId,
    uniqueId: detail.uniqueId,
    projectId: detail.projectId,
  });
}

